<div *ngIf="shouldShow" class="company-connectivity-main">
  <div class="main-actions">
    <div class="add-connection">
      <button class="vox-btn vox-btn-secondary" [disabled]="company.readOnly || isLocked"
      (click)="openAddConnectionPopup()" translate>company.connectivity.add</button>
    </div>
    <div *ngIf="!loading.lockUnlock" class="toggle-connection">
      <label class="vox-label" translate>company.connectivity.lock</label>
      <vox-toggle [(toggleOn)]="isLocked" [config]="toggle"
      (change)="lockUnlockConnections($event)"></vox-toggle>
    </div>
    <div *ngIf="loading.lockUnlock" class="toggle-connection">
      <ngx-skeleton-loader [theme]="{'height':'24px', 'width': '120px', 'margin-right': '15px', 'margin-bottom': '-9px'}"></ngx-skeleton-loader>
      <ngx-skeleton-loader [theme]="{'height':'24px', 'width': '48px', 'margin-right': '-48px', 'margin-bottom': '-9px'}"></ngx-skeleton-loader>
    </div>
  </div>
  <div class="vox-table">
    <table>
      <thead>
        <tr>
          <td>#</td>
          <td translate>company.connectivity.table.thead.provider.label</td>
          <td translate>company.connectivity.table.thead.address.label</td>
          <td translate>company.connectivity.table.thead.type.label</td>
          <td translate>company.connectivity.table.thead.actions.label</td>
        </tr>
      </thead>
      <tbody *ngIf="!loading.connections">
        <ng-container *ngFor="let c of connections">
          <tr>
            <td>
              <span class="vox-chip vox-chip_royal-blue-text">{{c.id}}</span>
            </td>
            <td>
              <span *ngIf="c?.provider_preview?.name">{{c.provider_preview.name}}</span>
              <span *ngIf="!c.provider_preview && !c.provider_preview.name"> - </span>
            </td>
            <td>
              <span *ngIf="c.address">
                Via {{c.address.building | titlecase}} {{c.address.number | titlecase}}, {{c.address.province | titlecase}}
              </span>
              <span *ngIf="!c.address"> - </span>
            </td>
            <td>
              <span *ngIf="c.type">
                <gdp-connection-type [type]="c.type"></gdp-connection-type>
              </span>
              <span *ngIf="!c.type"> - </span>
            </td>
            <td>
              <button class="vox-btn vox-btn-secondary"
                [routerLink]="[c.id]"
                [state]="{ company }"
                (click)="openConnection(c)"
                [ladda]="c.loading">
                {{'company.connectivity.table.details' | translate}}
              </button>
            </td>
          </tr>
        </ng-container>
      </tbody>
      <tbody *ngIf="loading.connections">
        <tr *ngFor="let i of [1,2,3,4]">
          <td colspan="7">
            <ngx-skeleton-loader [theme]="{'margin-bottom': 0}"></ngx-skeleton-loader>
          </td>
        </tr>
      </tbody>
      <tbody *ngIf="!loading.connections && connections.length === 0">
        <tr>
          <td colspan="7" translate>company.connectivity.table.empty</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
<router-outlet></router-outlet>
